import { useSelector } from "react-redux";
import GroceryItem from "./GroceryItem";
import styles from "./GroceryList.module.css";
const GroceryList = () => {
  const groceryItems = useSelector((state) => state.items.groceryItems);

  return (
    <ul className={styles["grocery_list"]}>
      {groceryItems.length === 0 && <p className={styles.no_item}>No Items found</p>}
      {groceryItems.length !== 0 &&
        groceryItems.map((groceryItem) => {
          return <GroceryItem key={groceryItem.id} {...groceryItem} />;
        })}
    </ul>
  );
};

export default GroceryList;
